<template>
  <Tooltip
    :content="pointsForUser"
    placement="top"
  >
    <Avatar
      :src="author.imageUrl"
      :size="size"
      :style="avatarStyle"
      class="author-avatar"
    >
      {{ authorInitial }}
    </Avatar>
  </Tooltip>
</template>

<script>
import { mapState } from 'vuex'

const COLORS = ['001f3f', '0074D9', '7FDBFF', '39CCCC', '3D9970', '2ECC40', '01FF70', 'FFDC00',
  'FF851B', 'FF4136', '85144b', 'F012BE', 'B10DC9']

export default {
  props: {
    author: {
      type: Object,
      default: () => {}
    },
    size: String
  },

  data () {
    return {
      colors: COLORS
    }
  },

  computed: {
    authorInitial () {
      return this.author.name.length ? this.author.name[0] : '?'
    },

    ...mapState('forum', {
      points: 'points'
    }),

    pointsForUser () {
      return this.points[this.author.id]
    },

    /**
     * Get an artificial random color for user avatar background
     */
    avatarColor () {
      const keyStr = this.author.name || this.author.email
      return `#${this.colors[(5 * keyStr.charCodeAt() + 7 * keyStr.length) % this.colors.length]}`
    },

    avatarFontSize () {
      switch (this.size) {
        case 'small':
          return '10px'
        case 'medium':
          return '12px'
        case 'large':
          return '16px'
        default:
          return '12px'
      }
    },

    avatarStyle () {
      return {
        '--background-color': this.avatarColor,
        '--font-size': this.avatarFontSize
      }
    }
  },

  mounted () {
    this.$store.dispatch('forum/fetchPoints')
  }
}
</script>

<style scoped>
.author-avatar {
  font-weight: bold;
  margin-right: 5px;
  background-color: var(--background-color);
  font-size: var(--font-size);
}
</style>
